import { Link } from 'react-router-dom';
import { Store, RotateCcw, ShieldCheck, Award } from 'lucide-react';

const items = [
  { icon: Store, text: 'Independent UK Retailer', href: null },
  { icon: RotateCcw, text: 'Easy UK Returns', href: '/account/returns' },
  { icon: ShieldCheck, text: 'Secure Checkout', href: null },
  { icon: Award, text: 'Split Soul Rewards', href: '/loyalty' },
];

export const TrustStrip = () => (
  <div className="bg-[#000] border-y border-[#222]" data-testid="trust-strip">
    <div className="px-6 md:px-12 lg:px-24 py-2.5 md:py-3.5">
      <div className="grid grid-cols-2 md:flex md:items-center md:justify-center gap-y-2 gap-x-4 md:gap-12 lg:gap-16">
        {items.map(({ icon: Icon, text, href }) => {
          const content = (
            <span className="flex items-center gap-1.5 md:gap-2">
              <Icon className="w-3.5 h-3.5 text-[#DEA193] flex-shrink-0" />
              <span className="text-[10px] md:text-xs tracking-[0.08em] md:tracking-[0.1em] text-white/70">{text}</span>
            </span>
          );
          return href ? (
            <Link key={text} to={href} className="hover:opacity-100 transition-opacity" data-testid={`trust-${text.toLowerCase().replace(/\s+/g, '-')}`}>
              {content}
            </Link>
          ) : (
            <div key={text} data-testid={`trust-${text.toLowerCase().replace(/\s+/g, '-')}`}>
              {content}
            </div>
          );
        })}
      </div>
    </div>
  </div>
);
